const Entities=function(opt){

    let i=0;let j=0;
     if(!opt)opt={};
     this._opt = opt;
     this._key= opt.key;
     if(!this._opt.orderBy){
       this._opt.orderBy={column:this._key,type:"int"};
     }
     
     this._master={}; //main _master
     this._clear=function(){
       this._master={};
       this._branches={};
     }
     
     this._optx={};
     for(var k in this._opt){
       if(k!="list"){
         this._optx[k]=this._opt[k];
       }
     }
     
     this._length=function(br){
       if(!br){br=this._master;}else{br=this._branches[br];}
       return Object.keys(br).length;
     }
     this.__getBranch=function(branch){
       return (branch && this._branches[branch])? this._branches[branch]:this._master;
     }
      this._orderBy=function(oOpt,b){
        var col =oOpt["column"];
       var tA=[];
       var br=this.__getBranch(b);
       var od1=[];
       for(var i in br){
         od1.push(br[i]);
       }
       od1.sort(function(a, b){
         var keyA,keyB;
           if(oOpt.type=="date"){
             keyA=new Date(a[col]);
             keyB= new Date(b[col]);
           }else{
              keyA = (a[col]+'').toLowerCase();
             keyB = (b[col]+'').toLowerCase();
           }
         // Compare the 2 dates
         if(oOpt.mode=="desc"){
         if(keyA > keyB) return -1;
         if(keyA < keyB) return 1;
           
         }else{
         if(keyA < keyB) return -1;
         if(keyA > keyB) return 1;
         }
         return 0;
       });
       
       return od1;
       
     };
     this._branches={};
     this._append=function(list){
       var kt=Object.keys(this._master).length;
       for(var k in list){
         kt++;
         if(!list[k][this._optx.key]){
           list[k][this._optx.key]=kt;
         }
        var rO={};
         for(var l in this._optx){
           rO[l]=this._optx[l];
         }
         var o = new Entity(list[k],rO);
         this._master[list[k][this._opt.key]+'']=o; //tochk
       }
     }
     this._has=function(col,val,br){
       br=this.__getBranch(br);
       var has=false;
       for(i in br){
         has|= (br[i][col].trim().toLowerCase()==val.trim().toLowerCase())
         if(has)break;
       }
       return has;
     }
     this._inArray=function(sOpt,br,toBr){
       br=this.__getBranch(br);
       this._branches[toBr]={};
       for(i in br){
        if(sOpt.array.includes(br[i][sOpt.column]+"")){
           this._branches[toBr][i]=br[i];
         }
       }
     }
     
     this._model=function(sOpt,key,br){
       let _tmpM={};
       br=this.__getBranch(br);
       for(let i in br){ 
         if(!sOpt.rules || br[i]._is(sOpt.rules)){
         if(sOpt.columns){
             let _tmpO={};
             for(let j in sOpt.columns){
               if(br[i][sOpt.columns[j]]){
                 _tmpO[sOpt.columns[j]]=br[i][sOpt.columns[j]];
               }
               _tmpM[br[i][key]]=_tmpO;
             }
         }else{
          // _tmpM[br[i][key]]=br[i]._toJson();
          let _ckV=br[i]._toJson();
        if(!_tmpM[br[i][key]]){
        _tmpM[br[i][key]]=_ckV;
        }else{
          for(let k in _ckV){
            _tmpM[br[i][key]][i]=(null!==_ckV[k]?_ckV[i]:_tmpM[br[i][key]][i]);
          }
        }
         }
       }
       }
       return _tmpM;
     };
     this._search=function(sOpt,br,toBr){
       br=this.__getBranch(br);
       this._branches[toBr]={};
       for(i in br){
        sOpt.mode=!sOpt.mode?'include':sOpt.mode;
         if((sOpt.mode=="exact" && br[i][sOpt.column]==sOpt.value) || 
         (sOpt.mode=="include" && br[i][sOpt.column].toLowerCase().includes(sOpt.value.toLowerCase()))){
           this._branches[toBr][i]=br[i];
         }
       }
     }
     this._searchAll=function(sOpt,br,toBr){
       br=this.__getBranch(br);
       this._branches[toBr]={};
       sOpt.mode=sOpt.mode!=undefined && sOpt.mode=="include";
       let cols=this._getColumns();
       for(i in br){
         if(sOpt.mode=='exact'){ //exact
           var chk=false;
           if(!Array.isArray(sOpt.rules)){
           for(j in sOpt.rules){
             let kw=sOpt.rules[j];
             chk |= (br[i][j]+"").toLowerCase()==(kw+"").toLowerCase();
             if(chk)break;
           }
         }else{
           for(j in cols){
             for(k in sOpt.rules){
               chk |= (br[i][cols[j]]+"").toLowerCase()==((sOpt.rules[k]+"").toLowerCase());
               if(chk)break;
             }
           if(chk)break;
           }
         }
           if(chk){
             this._branches[toBr][i]=br[i];
           }
         }else{ //include
           var chk=false;
           if(!Array.isArray(sOpt.rules)){
           for(j in sOpt.rules){
             let kw=sOpt.rules[j];
             chk |= (br[i][j]+"").toLowerCase().includes((kw+"").toLowerCase());
             if(chk)break;
           }
         }else{
           for(j in cols){
             for(k in sOpt.rules){
               chk |= (br[i][cols[j]]+"").toLowerCase().includes((sOpt.rules[k]+"").toLowerCase());
               if(chk)break;
             }
           if(chk)break;
           }
         }
           if(chk){
             this._branches[toBr][i]=br[i];
           }
         }
       }
     }
     this._consolidate=function(br,cols,values,folk){
       
       this._branches[folk]={};
       br=this.__getBranch(br);
       var key="";
       for(i in br){
         key="";
         for(j in cols){
           key+=br[i][cols[j]];
         }
         console.log('testCon-chk',key);
         if(!this._branches[folk].hasOwnProperty(key)){
           this._branches[folk][key]={...br[i]};
         }else{
           //append
           for(j in values){
            var bfV=parseFloat(this._branches[folk][key][values[j]]);
            var cV=parseFloat(br[i][values[j]]);
            this._branches[folk][key][values[j]]=bfV+cV;
            // if(this._branches[folk][key][values[j]].toFixed)
            // this._branches[folk][key][values[j]].toFixed(2)
           }
         }
       }
     };
     if(!this._opt.list){
       this._opt.list=[];
       if(this._opt.array && this._opt.arrayKey){
         for( i in this._opt.array){
           var li={};li[this._opt.arrayKey]=this._opt.array[i];
           this._opt.list.push(li)
         }
       }
     }
     this._append(this._opt.list);
     if(this._opt.client){
       this._client=this._opt.client;
     }
    
    this._refresh=function(list){
      this._master={};
      this._branches={};
      this._append(list);
    } 
     this._folk=function(branch,from,filter){ //folk branch
       if(from==undefined || from=="" || this._branches[from]==undefined){
         from=this._master
       }else{
         from=this._branches[from];
       }
       if(filter!==undefined){// apply filter
         this._branches[branch]={};
         for(var k in from){
           if(filter(from[k])){
             this._branches[branch][k]=from[k];
           }
         }
       }
       else{
           this._branches[branch]=from;
       }
     }
    
     this.__fun=function(br,kx,fx){
       br=this.__getBranch(br);
       if(fx!==undefined){
         for(i in br){
           br[i]["_"+kx]=fx;
         }
       }
       this["_"+kx]=function(fopt,o,p,q,r,s,t){
        
           var branch="";
           if(!fopt)fopt={};
           if(fopt.branch)
           branch=fopt.branch;
           branch=(branch && this._branches[branch])? this._branches[branch]:this._master;
           var pS=0;
           var pE=Object.keys(branch).length;
           if(fopt.page){
             if(!fopt.pageCount)fopt.pageCount=10;
             pS=(fopt.pageCount*fopt.page)-fopt.pageCount;
             pE=pS+fopt.pageCount-1;
           }
           
           var pIdx=0;
           
           var oded=this._orderBy(this._opt.orderBy,fopt.branch);
           if(this._opt.orderBy.column=="date"){
           }
           for(i in oded){
             if(pIdx>=pS && pIdx<=pE){
               if(oded[i]["_"+kx]){
               oded[i]["_"+kx](o,p,q,r,s,t);
               }
             }
             pIdx++;
           }
         }
     } 
     this._fun=function(br,kx,fx){
       var sfx=this;
       var promise = new Promise(function(resolve, reject) {
       /* missing implementation */
         sfx.__fun(br,kx,fx);
       resolve("Success");
     });
   
     return promise;
       
     };
     for(var k in this._opt){
       const kx=k;
       
       if(typeof this._opt[kx] == "function"){
         this._fun("",kx);
       }
     }
     this._getBy=function(col,val,getCol,branch){
       if(branch && this._branches[branch]){
         for(i in this._branches[branch]){
           if(this._branches[branch][i][col]==val)
           return this._branches[branch][i][getCol];
         }
       }
       else{
         for(i in this._master){
           if(this._master[i][col]==val)
           return this._master[i][getCol];
         }
       }
       return "";
     }
     this._sumBy=function(col,val,sumCol,br){
       var br=this.__getBranch(br);
       let rt=0;
         for(i in br){
           if(br[i][col]==val)
           {
             rt+=br[i][sumCol];
           }
         }
       
       return rt;
     }
     this._get=function(key,branch){
       if(branch && this._branches[branch]){
         return this._branches[branch][key];
       }
       return this._master[key];
     }
     this._checkout=function(branch,clean){
       this._master=this._branches[branch];
       if(clean){
         delete this._branches[branch];
       }
     }
     this._subKey=function(rules,col){
       var kid=1;
       for(var i in this._master){
         var mtch=true;
         for(var j in rules){
           mtch &= (this._master[i][j]==rules[j]);
            if(!mtch)break;
         }
         if(mtch){
         this._master[i][col]=kid++;
         }
       }
     }
     this._set=function(col,val,br,rules){
       let setDone=false;
       var br=this.__getBranch(br);
       
         for(i in br){
           if(!rules || br[i]._is(rules)){
             
             if(typeof val !== "function"){
             br[i][col]=val;
             }else{
               br[i][col]=val(br[i][col]);
             }
             setDone=true;
           }
         }
       
       return setDone;
     }
     this._where=function(rules,folk,cKey,br){
       if(!folk)folk="_temp_";
       var br=this.__getBranch(br);
       if(!cKey)cKey=this._opt.key;
       this._branches[folk]={};
       
       for(var i in br){
         if(br[i]._is(rules)){
         this._branches[folk][br[i][cKey]]=br[i];
         }
       }
       if(folk=="_temp_"){
         var rar=[];
         for(var i in this._branches[folk]){
           rar.push(this._branches[folk][i]);
         }
         return rar;
       }
     }
     this._toJson=function(br,rules,jObj,prePost,orderBy,orderMode,orderAs){
       
       if(!orderAs){
         orderAs='asc';
       }
       if(!orderMode){
         orderMode='text';
       }
       if(!br){
         br=this._master;
       }else{
         br=this._branches[br];
       }
       if(!rules){rules={};}
       if(undefined===jObj){jObj=true;}
       var arr=[];
       if(prePost){
         if(prePost.pre){
           arr.push(prePost.pre);
         }
       }
       for( i in br){
         var obj={};
         
       if(rules==undefined || br[i]._is(rules)){
         for(j in br[i]._master){
             obj[j]=br[i][j];
         }
         arr.push(obj);
       }
       }
       if(prePost){
         if(prePost.post){
           arr.push(prePost.post);
         }
       }
       if(orderBy){
         arr=Entities._u._array.order(arr,orderBy,orderMode,orderAs);
       }
       if(jObj){
         return arr;
       }else{
       return JSON.stringify(arr);
       }
     };
     this._first=function(br){
       if(!br){
         br=this._master;
       }
       else{
         br=this._branches[br];
       }
       for( i in br){
         return br[i];
       }
     }
     this._delete=function(id){
       var fList={};
       delete this._master[id];
     }
     this._column=function(br,k){
       br= this.__getBranch(br);
       var bro={};
       if(k){
        bro=br[k];
       }
       else{
         for(i in br){
           bro=br[i];break;
         }
       }
       var rar=[];
       for(i in bro){
         if(i[0]!="_"){
           rar.push(i);
         }
       }
       return rar;
     }
     this._getMergedColumnArrayData=function(cOpt,br,col,toObj){
        br=this.__getBranch(br);
       let ret=[];
       for(i in br){
         let arr=br[i][col];
         ret=ret.concat(arr);
       }
       
       ret= cOpt.mode && cOpt.mode=='unique'?Entities._u._array.unique(ret):ret;
       if(!toObj)return ret;
       let ck= Entities._u._array.toObjectList(ret,toObj);
       return ck;
     }
     this._getFirst=function(){
       for(i in this._master){
         return this._master[i];
       }
       return false;
     };
     this._getColumns=function(){
       if(!this._getFirst())return [];
       let o =this._getFirst()._toJson('',{},true);
       return Object.keys(o);
     };
     this._getColumnData=function(cOpt,br,rules){
       var tO={};
       var tOA=[];
       let tOO={};
       var br=this.__getBranch(br);
       
         for(i in br){
           
           if(br[i]._is(rules)){
               if(cOpt.columns){
                   let _o={};
              
               for(let j in cOpt.columns){
                   _o[cOpt.columns[j][1]]=br[i][cOpt.columns[j][0]];
               }
                   tOO[br[i][cOpt.columns[0][0]]]=_o;
                   
               }else if(cOpt.column){
                   tOA.push(br[i][cOpt.column]);
               }
           }
         }
         if(cOpt.mode=="unique"){
         if(cOpt.columns){
             for(let idx in tOO){
                 tOA.push(tOO[idx]);
             }
         }else{
           tOA=Entities._u._array.unique(tOA);
         }
         }
       
       if(cOpt.orderBy){
         tOA=Entities._u._array.order(tOA,cOpt.orderBy);
       }
       if(cOpt.priority){
         let _pr=[];
         for(let i in cOpt.priority){
           for(let j in tOA){
             if(tOA[j][cOpt.priority[i][0]]==cOpt.priority[i][1]){
               _pr.push(tOA[j]);
               delete tOA[j];
               if(_pr.length==cOpt.priority.length){
                 break;
               }
             }
           }
         }
         tOA=_pr.concat(tOA);
       }
       if(cOpt && cOpt.topping){
         tOA.splice( 0, 0, cOpt.topping );
       } 
       if(cOpt && cOpt.rottenEgg){
         tOA.push(cOpt.rottenEgg);
       }
       return tOA;
     }
     
     this._tableData=function(br,rules,exclude){
               var br= this._master;
       if(rules){
         this._where(rules,"__tableData"); //only master working
         br=this._branches.__tableData;
       }
               var sArr=[];
               for(i in br){
                 if(exclude){
                 sArr.push(Object.values(br[i]._exclude(exclude)));
                 }
                 else{
                   sArr.push(Object.values(br[i]._master))
                 }
               }
               return sArr;
           }
           
       this._collection=function(rules,br,struct){
         br=this.__getBranch(br);
         var rst=[];
         for(i in br){
           if(br[i]._is(rules)){
             var cO={};
             for(j in struct){
               cO[j]=br[i][struct[j]];
             }
             rst.push(cO);
           }
         }
         return rst;
       }
       this._clone=function(){
         return {...this};
       }
       this._map=function(callBack,br=""){
          br=this.__getBranch(br);
          let r=[];
          for(let i in br){
            r.push(callBack(br[i],i));
          }
          return r;
       }
       
     
   }
   Entities._extends=function(n,fun){
     Entities.prototype["_"+n]=fun;
   }
   
   Entities._u={
     
     _isFunction:function(functionToCheck) {
       return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
       },
     _templateEngine:function(html, options) {
       var re = /<%(.+?)%>/g,
           reExp = /(^( )?(var|if|for|else|switch|case|break|{|}|;))(.*)?/g,
           code = 'with(obj) { var r=[];\n',
           cursor = 0,
           result,
               match;
       var add = function(line, js) {
           js? (code += line.match(reExp) ? line + '\n' : 'r.push(' + line + ');\n') :
               (code += line != '' ? 'r.push("' + line.replace(/"/g, '\\"') + '");\n' : '');
           return add;
       }
       while(match = re.exec(html)) {
           add(html.slice(cursor, match.index))(match[1], true);
           cursor = match.index + match[0].length;
       }
       add(html.substr(cursor, html.length - cursor));
       code = (code + 'return r.join(""); }').replace(/[\r\t\n]/g, ' ');
       try { result = new Function('obj', code).apply(options, [options]); }
       catch(err) { console.error("'" + err.message + "'", " in \n\nCode:\n", code, "\n"); }
       return result;
   },
     _delay:function(f,arg){
       setTimeout(function(){
         f(arg);
       },30);
     },
     _array:{
       toObjectList:function(array,cols){
        
        let rt=[];let i,j;
         for(i in array){
           let ob={};
           for(j in cols){
             ob[cols[j]]=array[i];
           }
           rt.push(ob);
         }
         return rt;
       },
       order:function(arr,col,type,mode){
        var od1=[...arr];
       if(type===undefined){
         type='text';
       }
       if(mode===undefined){
         mode='asc';
       }
        od1.sort(function(a, b){
          var keyA,keyB;
            if(type=="date"){
              keyA=new Date(a[col]);
              keyB= new Date(b[col]);
            }else if(type=='number'){
              keyA=Entities._u._parseNum(a[col]);
              keyB=Entities._u._parseNum(b[col]);
            }
            else{
               keyA = (a[col]+'').toLowerCase();
              keyB = (b[col]+'').toLowerCase();
            }
          // Compare the 2 dates
          if(mode=="desc"){
          if(keyA > keyB) return -1;
          if(keyA < keyB) return 1;
            
          }else{
          if(keyA < keyB) return -1;
          if(keyA > keyB) return 1;
          }
          return 0;
        });
        
        return od1;
      },
       unique:function(arr) {
         var a = [];
         for (var i=0, l=arr.length; i<l; i++)
             if (a.indexOf(arr[i]) === -1 && arr[i] !== '')
                 a.push(arr[i]);
         return a;
       }
   },
     _prepare:{
       select:function(slt,arr,pres){
         var opts="";;
         if(pres){
           for(let i in pres){
             opts+="<option value='"+pres[i].value+"'>"+pres[i].html+"</option>";
           }
           
         }
         for(let i in arr){
           opts+="<option value='"+arr[i]+"'>"+arr[i]+"</option>";
         }
         document.getElementById(slt).innerHTML=opts;
       }
     },
     _prepareDigit:function(raw,dg){
       var cN=""
       var xted=false;
       var ctnx=0;
       for(var z in raw){
         if(raw[z]=="."){
           xted=true;
         }
         if(xted){
           ctnx++;
         }
           cN+=raw[z];
         if(ctnx==dg+3)
           break;
       }
         if(dg==0){
               console.info("before round",cN);
           raw=Math.round(cN);
               console.info("after digit",raw);
         }
         else if(xted)
           raw=parseFloat(cN);
         else
       raw=parseInt(cN);
         raw=Entities._u._digit(raw,dg);
   
         return raw;
       },
       _isFloat: function(t) {
       return t != "" && !isNaN(t) && Math.round(t) != t;
       },
       _isInteger: function(n) {
       if ((undefined === n) || (null === n) || ""===n) {
       return false;
       }
       if(isNaN(n%1))
       return false;
       else
       return n % 1 == 0;
       },
       _isNegative: function(n) {
       if ((undefined === n) || (null === n)) {
       return false;
       }
       return n < 0;
       }                ,
       _getType: function(input) {
       var m = (/[\d]+(\.[\d]+)?/).exec(input);
               if (m) {
       // Check if there is a decimal place
       if (m[1]) {
       return 'float';
       }
       else {
       return 'int';
       }
       }
       return 'string';
       },
       _formatComma:function(nStr,fixed) {
         nStr=Entities._u._parseNum(nStr,fixed);
       nStr += '';
   
              let x = nStr.split('.');
              let x1 = x[0];
              let x2 = x.length > 1 ? '.' + x[1] : '';
               var rgx = /(\d+)(\d{3})/;
               while (rgx.test(x1)) {
       x1 = x1.replace(rgx, '$1' + ',' + '$2');
       }
       return x1 + x2;
       },
       _parseNum:function(nStr,lg){
         var rv="";
         nStr=nStr+'';
         if(!lg){
           lg=2;
         }
         for(let i in nStr){
           if(nStr[i]!="$" && nStr[i]!=","){
             rv+=nStr[i];
           }
         }
         if(rv.includes(".")){
         rv= parseFloat(rv);
         rv=parseFloat(rv.toFixed(lg));
         }else{
           rv=parseInt(rv);
         }
        //alert(typeof rv);
         return isNaN(rv)?0:rv;
       },
       _arrToList:function(arr,cols){
           let ret=[];
           for(let i in arr){
              let _o={};
              for(let j in cols){
                  _o[cols[j]]=arr[i];
              }
              ret.push(_o);
           }
           return ret;
       },
       _clone:function(obj) {
        if (null == obj || "object" != typeof obj) return obj;
        return {...obj};
        // var copy = obj.constructor();
        // for (var attr in obj) {
        //     if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
        // }
        return {...obj};
    }
   };
   const Entity=function(obj,opt){
       let i=0;let j=0;
     if(!opt)opt={};
     this._opt=opt;
     this._master=obj; // main object
   
     this.__parse=function(){
       for(var k in this._master){
         this[k]=this._master[k];
       }
     }
     this.__parse();
   
     this._sync=function(o){
       if(o){
         for(var k in o){
           this[k]=o[k];
         }
       }
       if(!this._master){
        this._master={};
       }
       for(var k in this){
         if(k[0]!="_" && typeof this[k] !== "function"){
           this._master[k]=this[k];
         }
       }
     }
   
     this._branches={};
     this._folk=function(branch,from,ovr,clone){ //folk branch
       if(from==undefined || from=="" || this._branches[from]==undefined){
         from=this._master;
       }else{
         from=this._branches[from];
       }
       if(clone){
       this._branches[branch]=Entities._u._clone(from) //{...from};
         
       }else{
       this._branches[branch]=from;
       }
       for(var k in ovr){
         if(clone){
         this._branches[branch][k]=Entities._u._clone(ovr[k])//{...ovr[k]};
         }else{
           this._branches[branch][k]=ovr[k];
         }
       }
     }
     this._clear=function(){
       this._branches={};
     }
     this._checkout=function(branch,clean){
       this._master=Entities._u._clone(this._branches[branch]) //{...this._branches[branch]};
       this.__parse();
       if(clean){
         delete this._branches[branch];
       }
     }
     for(var x in this._opt){
       if(typeof this._opt[x] == "function"){
         this["_"+x]=this._opt[x];
         delete this._opt[x];
       }
     }
     this._get=function(key,branch){
       if(branch && this._branches[branch]){
         return this._branches[branch][key];
       }
       return this._master[key];
     }
   
     this._request=function(page,data){
       //rest client for pagination
     }
   
   
   if(this._init && typeof this._init== "function"){
     this._init();
     this._sync();
   }
   var thisObj=this;
   
   this._overwrite=function(obj){
       for(i in obj){
         this[i]=obj[i];
       }
       this._sync();
     }
     this._on=function(id,col,callback){
       if(this[col]==id){
         callback();
       }
     }
     this._runByKey=function(as){
       as[this[this._opt.key]]();
     };
     
     this._is=function(rules){
        let arrMode=false;
         let mtch=true;
         for(let j in rules){
           if(Entities._u._isFunction(rules[j])){
             mtch=rules[j](this);
           }
           else if(Array.isArray(rules[j])){
             arrMode=true;
             let _sign=rules[j][1];
             let _mode=rules[j][2];
             let _v=rules[j][0];
            if(_sign=='includes'){
             eval("mtch "+_mode+"=_v.includes(this[j]);");
            }else{
             eval("mtch "+_mode+"=this[j]"+_sign+"'"+_v+"';");
            }
           }else{
             mtch &= (this[j]==rules[j]);
           }
            if(!arrMode && !mtch)break;
         }
         return mtch;
       }
     this._only=function(cols,c){
       var rt={};
       for(i in cols){
         rt[cols[i][c]]=this[cols[i][c]];
       }
       return rt;
     }
     this._exclude=function(cols){
       var rt={};
       for(i in this._master){
         if(!cols.includes(i)){
           rt[i]=this._master[i];
         }
       }
       return rt;
     }
     this._getVar=function(idx){
             if(!this._template && !this._template.vars){
               return "";
             }else{
               return this[this._template.vars[idx]];
             }
           }
       this._toJson=function(){
         var rt={};
         for(i in this){
         if(typeof this[i] !=='function'){
         rt[i]=this[i];
         }
         }
         return rt;
       }
       this._toArray=function(){
         var rt=[];
         for(i in this._master){
           rt.push(this[i]);
         }
         return rt;
     }
     this._refresh=function(d){
       this._sync(d);
       this._init();
     }
     
   }
   export {Entity,Entities};